import React, { useState } from 'react';

import styled from '@emotion/styled';

import CollapsableControl from './CollapsableControl';

interface CollapsibleContainerProps {
  children: React.ReactNode;
  title?: string | React.ReactNode;
  open?: boolean;
}

const CollapsibleContainer: React.FC<CollapsibleContainerProps> = ({
  children,
  title,
  open = false,
}) => {
  const [isCollapse, setIsCollapse] = useState(() => open);
  return (
    <Container>
      <LabelSection>
        {title && <Label>{title}</Label>}

        <CollapsableControl
          isCollapse={isCollapse}
          setIsCollapse={setIsCollapse}
        />
      </LabelSection>
      {/* Always mounted; hidden via CSS so child component state is preserved */}
      <ChildrenWrapper isVisible={isCollapse}>{children}</ChildrenWrapper>
    </Container>
  );
};

export default CollapsibleContainer;

const Container = styled.div`
  /* border: 1px solid ${({ theme }) => theme.palette.borderColor}; */
  /* padding: 24px; */
  /* border-radius: 10px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  background-color: white;

  &.collapse {
    gap: 0px;
  }
`;

export const LabelSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  width: fit-content;

  color: ${({ theme }) => theme.palette.primaryTextColor};
`;

const ChildrenWrapper = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'contents' : 'none')};
`;
